import { useMemoizedFn } from "ahooks";
import dayjs from "dayjs";
import { useEffect, useRef } from "react";
import { destroyAll } from "../HBModal/ModalWrap";
import { AdditionGoodDialog, BuyVipDialog, VipAuthDialog } from "../Vip";
// import { getCounpons } from "@/services";
// import { COUPON_STATUS } from "@/constants/coupon";
import useAppStore from "@/context/store";
import GuideDialog from "@/pageComponents/Guide/GuideDialog";
import { PRESETS_CONDITION, stewardInstance } from "@/utils/steward";
import { useRouter } from "next/router";
import { useLogin } from "../LoginModal";

// 第一次弹框Hook, 用于处理进入页面时需要弹框的逻辑
const useFirstModal = function () {
  const { vips, expiredVips, user } = useAppStore(
    ({ vips, expiredVips, user }) => ({
      vips,
      expiredVips,
      user,
    })
  );
  const { login } = useLogin();
  const router = useRouter();

  // 购买vip弹框通过hash地址唤起
  const handleBuyVipHash = useMemoizedFn(() => {
    const actionsMap = {
      buyVip: BuyVipDialog.open,
      buyVipAuthExtend: VipAuthDialog.open,
      buyAddition: AdditionGoodDialog.open,
    };
    const hash = (window.location.hash || "").split("#")[1];

    if (!hash) {
      return;
    }

    const [action, type, pkgs = "", versionTab] = (hash || "").split("-");

    const [selectedPkg, selectedPlusSku] = pkgs.split("+");

    if (actionsMap[action]) {
      if (user) {
        // 关闭其他弹窗，避免相互影响
        destroyAll();
        actionsMap[action]({
          type: type || "personal",
          selectedPkg: (selectedPkg || "").split(";"),
          afterClose() {
            window.location.hash = "";
          },
          /**企业会员选中Version（基础授权、高级授权）使用 */
          versionTab: versionTab,
          defaultSelectPlusSku: selectedPlusSku,
        });
      } else {
        login();
      }
    }
  });

  useEffect(() => {
    user?.user_id && handleBuyVipHash();
  }, [handleBuyVipHash, user?.user_id, router]);

  useEffect(() => {
    window.addEventListener("hashchange", handleBuyVipHash);

    return () => {
      window.removeEventListener("hashchange", handleBuyVipHash);
    };
  }, [handleBuyVipHash]);

  // 轻舟用户商业化场景触达，触发轻舟配置的条件
  useEffect(() => {
    if (!user) return;

    // 会员过期前N天触发
    if (vips.length) {
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.HUABAN_VIP_EXPIRE_BEFORE_DAYS,
        {
          condition: dayjs(user.extra?.material_vip_expire_at).diff(
            dayjs(),
            "day",
            true
          ),
        }
      );
    }

    // 会员滚起后N天触发
    if (expiredVips?.length && !vips.length) {
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.HUABAN_VIP_EXPIRE_AFTER_DAYS,
        {
          condition: dayjs().diff(
            dayjs(user.extra?.material_vip_expire_at),
            "day",
            true
          ),
        }
      );
    }
  }, [expiredVips, user, vips]);

  // 新人引导
  const guideDialogInst = useRef();
  useEffect(() => {
    // 未登录不弹
    if (!user) return;
    // 防止重复打开
    if (guideDialogInst.current) return;
    // 关注页有内容就不弹 已经有职业或者领域的、 或者有关注内容的（画板，用户，专题、来源）用户不再弹出
    if (
      user?.extra?.job_id ||
      user?.extra?.job_ids?.length ||
      user?.following_count ||
      user?.board_following_count ||
      user?.domain_count ||
      user?.explore_following_count
    ) {
      // 全局弹窗
      stewardInstance.trigerAwaitInit(
        PRESETS_CONDITION.CUR_PROJECT_ENTER_TIMES,
        {
          needRemoveTrigger: true,
        }
      );
      return;
    }

    // 采用的方案：新手引导页面，是一个强全局弹窗，不可跳过
    guideDialogInst.current = GuideDialog.open({
      closable: false,
    });
  }, [user]);
};

export default useFirstModal;
